module.exports = __webpack_public_path__ + "img/CH01-022-023.2773d4b1.jpg";